// Source: app/scripts/controllers/footer.js
Auction.controller('FooterController', [
  '$scope',
  '$filter',
  '$routeParams',
  '$location',
  'toaster',
  'crudService',
  '$modal',
  'Downloader',
  'Messages',
  'ngTableParams',
  function ($scope, $filter, $routeParams, $location, toaster, crudService, $modal, Downloader, Messages, ngTableParams) {

    var helpTemplatesService = crudService('document_template_vocabulary', {
      'getHelpTemplates': {
        method: 'GET',
        isArray: true,
        url: '/data/rest/document_template_vocabulary/by_group'
      }
    });
    $scope.showHelpTemplates = false;
    helpTemplatesService.getHelpTemplates({code: 'HELP'}, function (data) {
      $scope.helpTemplates = data;
      $scope.showHelpTemplates = true;
      $scope.tableParams = new ngTableParams({
        count: $scope.helpTemplates.length // hides pager
      },{
        counts: [] // hides page sizes
      });
    });

    $scope.downloadHelpTemplateAttachment = function (templateId) {
        if(templateId) {
          Downloader.download('/data/rest/portal_attachments/get_document_template_vocabulary_template/' + templateId);
        }
      };


  }
]);
